import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import HealthSendMessage from "./Health/SendMessage";
import TravelSendMessage from "./Travel/SendMessage";
import ServiceSendMessage from "./ServiceBot/SendMessage";
import HomeSendMessage from "./Home/SendMessage";
import ServiceRestartChatConfirmation from "./ServiceBot/chatElements/RestartChatConfirmation";
export default function RestartChatConfirmation({
    isService, productId, GAEvent, restartChat,setHaveExistingChat,
}) {

    const confirmationAction = (val) => {
        setHaveExistingChat(false);
      if (val) {
       restartChat()
      }
    }
   

    return (
        <>
            {
                isService ?
                    <ServiceRestartChatConfirmation
                    confirmationAction={confirmationAction}
                    /> : null}

        </>
    );
}
